module.exports = __webpack_public_path__ + "static/media/IconMapFavActive.bb564b3d.svg";